import { useMutation } from "@tanstack/react-query";
import { deleteAdmin } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export function useDeleteAdmin() {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  return useMutation({
    mutationFn: async ({ userId, email }) =>
      deleteAdmin({ clientId: id, userId, email }),
  });
}
